// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { FormatStatus } from 'components/DataTable'

import {
  FormatBandwidthHeader,
  FormatFrequencyHeader,
  FormatModulation,
  FormatPowerHeader,
  FormatThresholdHeader,
} from './Formatters'

const columns = [{
  columnKey: 'radioCode',
  columnHeader: 'Code',
  columnWidth: '80px',
  sortable: true,
}, {
  columnKey: 'companyName',
  columnHeader: 'Manuf.',
  sortable: true,
}, {
  columnKey: 'radioFamilyName',
  columnHeader: 'Model Family',
  sortable: true,
}, {
  columnKey: 'modelNumberConcatenated',
  columnHeader: 'Model',
  columnHeaderTitle: 'Model number for highest modulation',
  sortable: true,
}, {
  columnKey: 'bandwidth',
  columnHeader: 'BW',
  columnWidth: '70px',
  headerFormatter: FormatBandwidthHeader,
  sortable: true,
}, {
  columnKey: 'txPowerMax',
  columnHeader: 'Power',
  columnWidth: '80px',
  headerFormatter: FormatPowerHeader,
  sortable: true,
}, {
  cellFormatter: FormatModulation,
  columnKey: 'modulations',
  columnHeader: 'Mbps',
  columnWidth: '70px',
  sortable: true,
}, {
  columnKey: 'modulationSchemeDescription',
  columnHeader: 'Mod.',
  columnWidth: '80px',
  columnHeaderTitle: 'Highest modulation',
  sortable: true,
}, {
  columnKey: 'modulationDescription',
  columnHeader: 'Mod. Desc.',
  sortable: true,
}, {
  columnKey: 'rxThreshold',
  columnHeader: 'Threshold',
  columnWidth: '80px',
  headerFormatter: FormatThresholdHeader,
  sortable: true,
}, {
  columnKey: 'frequency',
  columnHeader: 'Frequency (MHz)',
  headerFormatter: FormatFrequencyHeader,
  columnWidth: '120px',
  sortable: true,
}, {
  columnKey: 'specDate',
  columnHeader: 'Spec Date',
  columnWidth: '80px',
  sortable: true,
}, {
  cellFormatter: FormatStatus,
  columnKey: 'status',
  columnHeader: 'Status',
  columnWidth: '50px',
  sortable: true,
}]

export default columns
